/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Status
 */
export type GetPaginationTransferTransactionsResponseDataItemStatus = typeof GetPaginationTransferTransactionsResponseDataItemStatus[keyof typeof GetPaginationTransferTransactionsResponseDataItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPaginationTransferTransactionsResponseDataItemStatus = {
  pending: 'pending',
  success: 'success',
  void: 'void',
} as const;
